import { styled } from '@mui/material';
import React from 'react';

// Outer wrapper that provides the outside frame and positioning context
const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  marginInline: '12px',
  marginTop: '28px',
  marginBottom: '12px',
}));

// Visible outer border per Figma (#889eaa). Container for inner content
const OuterBorder = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  border: '1px solid #889eaa',
  borderRadius: '12px',
  boxSizing: 'border-box',
  display: 'flex',
}));

// Inner lighter border container; holds title badge and children
const InnerBorder = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  border: '1px solid #f5f6f6',
  borderRadius: '11px',
  boxSizing: 'border-box',
  padding: '1px',
  display: 'flex',
  flexDirection: 'column',
}));

const Content = styled('div')(({ contentPaddingTop, contentPaddingBottom }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  position: 'relative',
  width: '100%',
  height: '100%',
  paddingInline: '12px',
  paddingBottom: contentPaddingBottom,
  paddingTop: contentPaddingTop,
}));

// Title badge that sits on the top border line

const TitleBadge = styled('div')(() => ({
  position: 'absolute',
  top: '-7px',
  left: '16px',
  backgroundColor: '#E9ECED',
  paddingLeft: '6px',
  paddingRight: '6px',
  height: '10px',
  display: 'flex',
  alignItems: 'center',
}));

const TitleText = styled('p')(() => ({
  margin: 0,
  fontWeight: 500,
  color: '#394B57',
  fontSize: '24px',
  lineHeight: '24px',
  whiteSpace: 'nowrap',
  textShadow: '#ffffff 0.5px 1px 0px, rgba(0,0,0,0.4) -0.5px -0.5px 0px',
  userSelect: 'none',
}));

// Props mirror existing API and add a `title` prop for the label
const CardTitle = ({
  title = 'Window Title',
  contentPaddingTop = '32px',
  contentPaddingBottom = '12px',
  ...props // contains everything else like className, sx, children etc.
}) => {
  const { sx, ...rest } = props; // destructure sx and rest of props
  const defaultSx = { width: '100%', minWidth: '300px', height: '100%', marginTop: '28px' };

  return (
    <Root sx={[defaultSx, sx]} {...rest}>
      {' '}
      {/* merge defaultSx with sx and rest of props */}
      <OuterBorder>
        <InnerBorder>
          <TitleBadge>
            <TitleText>{title}</TitleText>
          </TitleBadge>
          <Content
            contentPaddingTop={contentPaddingTop}
            contentPaddingBottom={contentPaddingBottom}
          >
            {props.children}
          </Content>
        </InnerBorder>
      </OuterBorder>
    </Root>
  );
};

export default CardTitle;
